import { render, staticRenderFns } from "./NextEvent.vue?vue&type=template&id=13747ac2&scoped=true&lang=pug&"
import script from "./NextEvent.vue?vue&type=script&lang=ts&"
export * from "./NextEvent.vue?vue&type=script&lang=ts&"
import style0 from "./NextEvent.vue?vue&type=style&index=0&id=13747ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13747ac2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
